import __ from "standard/dunder";

const willPaint = (target, propertyKey) => {
  Reflect.defineProperty(target, __.willPaint__, {
    value() {
      return this[propertyKey](...arguments);
    },
    writable: true,
  });
};

export default willPaint;
